import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from 'constants/api';
import axios from 'helpers/axios';

const CAMPAIGN_PARAM = 'campaign';

export default () => {
  const location = useLocation();
  const [isUnlocking, setIsUnlocking] = useState(
    new URLSearchParams(location.search).has(CAMPAIGN_PARAM),
  );

  const campaign = new URLSearchParams(location.search).get(CAMPAIGN_PARAM);

  useEffect(() => {
    if (!campaign) {
      return;
    }

    axios.post(api.achievements.unlock()).finally(() => setIsUnlocking(false));
  }, [campaign]);

  return isUnlocking;
};
